import React, { useEffect, useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { ServicePageHeader } from "@/components/ServiceHistoryButton";
import { SimammaBadge } from "@/components/Logo";
import { HOUSE_OPERATOR } from "@/lib/brand";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export default function SimammaTopup() {
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [phone, setPhone] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/products", { params: { category: "ricarica" } }).then((r) => setProducts((r.data || []).filter((p) => p.operator === HOUSE_OPERATOR))).catch(() => {});
    api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, []);

  const checkout = async () => {
    if (!selected) { toast.error("Seleziona un taglio di ricarica"); return; }
    if (!phone) { toast.error("Inserisci il numero di telefono"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/wallet/pay", { product_id: selected, quantity: 1, phone_number: phone, customer_id: customerId || null });
      toast.success(`Ricarica completata! Scalati ${euro(data.amount)} dal Plafond servizi.`);
      setSelected(null); setPhone("");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="service-page-wide space-y-5 w-full max-w-none" data-testid="simamma-topup-page">
      <ServicePageHeader service="ricariche">
        <div className="flex items-center gap-2"><SimammaBadge /><span className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Servizio operatore</span></div>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-2" data-testid="simamma-topup-title">Ricarica SiMamma</h1>
      </ServicePageHeader>
      <Card className="topup-layout p-5 glow-border">
        <div className="topup-fields space-y-4">
          <div>
            <Label>Cliente (opzionale)</Label>
            <Select value={customerId} onValueChange={setCustomerId}>
              <SelectTrigger className="mt-1.5" data-testid="sm-ricarica-customer-select"><SelectValue placeholder="Associa a un cliente" /></SelectTrigger>
              <SelectContent>{customers.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label htmlFor="sm-ricarica-phone">Numero SiMamma</Label><Input type="tel" id="sm-ricarica-phone" className="mt-1.5" data-testid="sm-ricarica-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+39 3xx xxxxxxx" /></div>
        </div>
        <div className="topup-offers">
          <Label>Taglio ricarica SiMamma</Label>
          <div className="topup-offer-grid gap-3 mt-2">
            {products.map((p) => (
              <button key={p.id} type="button" data-testid={`sm-ricarica-option-${p.id}`} onClick={() => setSelected(p.id)}
                className={`rounded-xl border p-4 text-center transition-all ${selected === p.id ? "border-primary bg-primary/10 ring-2 ring-primary" : "border-border hover:border-primary/50"}`}>
                <p className="font-head text-xl font-bold">{euro(p.price)}</p>
                <p className="text-xs text-muted-foreground mt-1">SiMamma</p>
              </button>
            ))}
          </div>
          {products.length === 0 && <p className="text-xs text-amber-500 mt-2">Nessun taglio disponibile.</p>}
        </div>
        <Button onClick={checkout} disabled={loading} className="topup-submit gap-2" data-testid="sm-ricarica-checkout-button">
          <RefreshCw className="w-4 h-4" /> {loading ? "Attendi…" : "Paga con Plafond"}
        </Button>
      </Card>
    </div>
  );
}
